<template>
<v-dialog persistent v-model="resetRootDialog">
  <v-card color="rgba(255, 255, 255, 0.7)" class="border-radius-15 modal-class">
    <v-container id="root-dialog" pa-0>
      <v-layout id="fdi-reset-password-form" column justify-center>
        <v-flex mt-3 mx-2>
          <h1 class="text-xs-center">New Password Request</h1>
          <h5 class="text-xs-center prestige">Enter your Username to retrieve email code</h5>

        </v-flex>
        <v-flex xs12 d-flex justify-center align-center>
          <v-flex xs12 sm6 md4>
            <v-alert my-0 py-0 v-if="error" value="error" type="error">
              {{ error }}
            </v-alert>
            <v-alert my-0 py-0 v-else-if="successMsg" value="successMsg" type="success">
              {{ successMsg }}
            </v-alert>
            <div id="error-spacer" v-else>

            </div>
          </v-flex>
        </v-flex>
        <v-flex class="prestige" xs12 d-flex justify-center align-center>
          <v-flex xs9 md4>
            <v-text-field @keyup.enter.stop.prevent v-model="username" full-width single-line name="username" label="USERNAME" id="username">
            </v-text-field>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-container>
    <v-card-actions class="mb-3">
      <v-spacer></v-spacer>
      <v-btn flat @click="backToSignIn">
        <v-img :src="backButton" />
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn block large outline color="black" class="button-bor" flat :disabled="!username" @click="send">request code</v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>

  <v-dialog persistent v-model="newPasswordDialog">
    <v-card color="rgba(255, 255, 255, 0.5)" class="border-radius-15 modal-class">
      <v-container id="root-dialog" pa-0>
        <v-layout id="fdi-reset-password-form" column justify-center>
          <v-flex mt-3>
            <h1 class="text-xs-center">update password</h1>
            <h5 class="text-xs-center prestige">Password Criteria:<ol class="text-xs-left mt-1">
                <li>Must be 8 or more characters</li>
                <li>Must have at least 1 uppercase character</li>
                <li>Must have at least 1 Number</li>
              </ol>
            </h5>

          </v-flex>
          <v-flex xs12 d-flex justify-center align-center>
            <v-flex xs12 sm6 md4>
              <v-alert my-0 py-0 v-if="error" value="error" type="error">
                {{ error }}
              </v-alert>
              <v-alert my-0 py-0 v-else-if="successMsg" value="successMsg" type="success">
                {{ successMsg }}
              </v-alert>
            </v-flex>
          </v-flex>
          <v-flex class="prestige" xs12 d-flex justify-center align-center mt-5>
            <v-flex xs9 md4>
              <v-text-field @keyup.enter.stop.prevent v-model="code" name="code" single-line label="Enter the code sent to your email" id="code">
              </v-text-field>
              <v-text-field @keyup.enter.stop.prevent v-model="password" type="password" single-line name="password" label="NEW PASSWORD" id="password">
              </v-text-field>
              <v-text-field @keyup.enter.stop.prevent v-model="password2" type="password" single-linename="password2" label="RETYPE PASSWORD" id="password2">
              </v-text-field>
            </v-flex>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions class="my-3">
        <v-spacer></v-spacer>
        <v-btn flat @click="backToSignIn">
          <v-img :src="backButton" />
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn block large outline color="black" class="border-button" @click="submit">submit</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>

    </v-card>
  </v-dialog>
</v-dialog>
</template>

<script>
import { Auth, Logger } from "aws-amplify";
import AmplifyStore from "@/store";
import backButtonBlk from "@/assets/buttons/back-blk.png";

export default {
  name: "ForgotPassword",
  data() {
    return {
      username: "",
      code: "",
      password: "",
      password2: "",
      error: null,
      successMsg: "",
      resetRootDialog: true,
      newPasswordDialog: false,
      email: "",
      backButton: backButtonBlk
    };
  },
  computed: {
    user() {
      return AmplifyStore.state.amplify.user;
    },
    mainLoginButtonSize() {
      let height = this.$store.getters.appInnerHeight;
      if (height < 600) {
        return 100;
      } else if (height > 600 && height < 700) {
        return 125;
      } else if (height > 700) {
        return 150;
      }
    }
  },
  methods: {
    send: function() {
      Auth.forgotPassword(this.username)
        .then(response => {
          console.log("code resent", response);
          this.email = response.CodeDeliveryDetails.Destination;
          this.error = "";
          this.successMsg = "Code Sent To Your Email Address";
          setTimeout(() => {
            this.successMsg = "";
            this.resetRootDialog = false;
            this.newPasswordDialog = true;
          }, 1000);
        })
        .catch(err => {
          console.log(err);
          switch (err.code) {
            case "UserNotFoundException":
              this.error =
                "Username and/or Code is invalid.  Please try again or request a new code.";
              break;
            case "NotAuthorizedException":
              this.error =
                "You must first login with the temporary password sent to your email address";
              break;
            default:
              this.setError(err);
          }
        });
    },
    submit: function() {
      Auth.forgotPasswordSubmit(this.username, this.code, this.password)
        .then(res => {
          console.log(res);
          this.$router.push("/");
        })
        .catch(err => {
          console.log(err.code);
          switch (err.code) {
            case "UserNotFoundException":
              this.error =
                "Username and/or Code is invalid\nPlease try again or request a new code.";
          }
          this.setError(err);
        });
    },
    backToSignIn: function() {
      this.$router.push("/auth/signIn");
    },
    setError: function(err) {
      this.error = err.message || err;
    }
  }
};
</script>

<style>
#forgot-password {
  height: 100%;
  background-image: url("../../../assets/paper_bkgd.png");
  background-size: cover;
  background-position: center;
}

.prestige {
  font-family: "PrestigeElite-STD";
}

#error-spacer {
  height: 80px;
}

#fdi-reset-password-form .v-text-field__slot label {
  text-align: center;
  width: 100%;
  margin-left: 10px;
  margin-right: 10px;
  font-family: "BebasNeueRegular";
}

#fdi-reset-password-form .v-text-field__slot input {
  border-bottom: 2px solid black;
  padding-bottom: 1px;
}
</style>
